

import React, {Component} from 'react';
import { Redirect } from "react-router-dom";
import withNofeshService  from '../../hoc/withNofeshService.hoc';
import compose from '../../utils/compose'

class HotelForOrderItem extends Component {

    state = {
        redirect : null,
        totalPrice:'',
        showTotalPrice:false
    }


    DisplayForHotelDetails = (hotelId) => {        

        console.log('DisplayForDetails hotelId', hotelId);
        this.props.DisplayForHotelDetails(hotelId);
    }

    DisplayForOrder = (AllocationId,obj) => {        
        console.log(obj);


        if ( window.NOFESH_ORDER_PAGE =="YES") {
            this.setState({ redirect: "/order/" + AllocationId});  

        }   

        let data = {};
        data.hotelForOrder = this.props.hotelForOrder;
        data.replaceOrder = 0;
        this.props.DisplayForOrder(data);
    }

    DisplayPriceForOrder = () => {        
  
        const { nofeshService } = this.props;
        const { hotelForOrder } = this.props;
        nofeshService.getTotalPrice(hotelForOrder).then( res  => {    
      
            console.log('HotelForOrderItem DisplayPriceForOrder   res.data: ', res.data);
            let  resultObj = res.data;
            
            this.setState({ 
                totalPrice:resultObj,
                showTotalPrice: true
            }); 
        }); 
        
 
    }

    
  render() { 

    
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    }  
            
    return (     
        

        <div className="inner_col">
            <div className="inner_col_htl_img">
                <img src={this.props.hotelForOrder.HotelFirstPic}  alt=""/>
            </div>
            <div className="inner_col_htl_main_title_container">
                <div className="inner_col_htl_main_title directionRtl">{this.props.hotelForOrder.HotelName}</div>
                <div className="inner_col_htl_sec_title_container">
                    <span className="inner_col_htl_sec_title directionRtl">{this.props.hotelForOrder.HotelArea}</span>
                </div>

                <div className="orderButton" onClick={ () => 
                    this.DisplayForHotelDetails(this.props.hotelForOrder.HotelId)}>
                    <div className="orderArrow">
                        <img src={"/images/site/arrow-next.png"} alt=""/>                
                    </div>
                    <div className="hotelDetailsText">פרטי מלון</div>
                </div>
            </div>

            <div className="inner_col_htl_details inner_col_htl_details_font">
                <span className="marginRight24 inner_col_htl_details_2">
                    <img src={"./images/site/complete-2.png"} alt=""/>
                    <span className="inner_col_htl_date marginRight5">
                            {this.props.hotelForOrder.StartVacationDateFormatted}
                            &nbsp;-&nbsp;
                            {this.props.hotelForOrder.EndVacationDateFormatted}
                    </span>

                    <span className="inner_col_htl_date marginRight5">
                            &nbsp;&nbsp;
                            {this.props.hotelForOrder.StartVacationWeekDay}'
                            &nbsp;-&nbsp;
                            {this.props.hotelForOrder.EndVacationWeekDay}'
                    </span>
                </span>
            </div>

            <div className="marginTop14 inner_col_htl_details inner_col_htl_details_font">
                <span className="marginRight24 inner_col_htl_details_2">
                    <img src={"./images/site/night-2.png"} alt=""/>
                    <span className="directionRtl">
                        {this.props.hotelForOrder.TotalNights}
                        &nbsp;
                        לילות

                    </span>
                </span>

                <span className="marginRight15 inner_col_htl_details_2">
                    <img src={"./images/site/room-2.png"} alt=""/>
                    <span className="directionRtl">
                        {this.props.hotelForOrder.RoomsNum}
                        &nbsp;
                        חדרים
                        </span>
                </span>

                <span className="marginRight15 inner_col_htl_details_2">
                    <span className="directionRtl">
                        {this.props.hotelForOrder.weekendOrDays}
                        
                    </span>
                </span>
            </div>

            <div className="inner_col_htl_details inner_col_htl_details_font">
                <span className="marginRight24 inner_col_htl_details_2">
                    <img src={"./images/site/cost-2.png"} alt=""/>

                    {(this.props.hotelForOrder.NightsOnEmployee == 0) ?
                        <span className="directionRtl">
                            {this.props.hotelForOrder.TotalPrice}
                        </span>
                        :
                        
                        <span>
                            {(!this.state.showTotalPrice) ?
                            <span className="getPriceTitle" onClick={ () =>  this.DisplayPriceForOrder()}>
                                לבירור המחיר
                            </span>
                            :
                            <span className="directionRtl">
                                {this.state.totalPrice}
                            </span>
                            }
                        </span>
                    }
                </span>
            </div>

            
            <div className="orderButtonContainer" >
                <div className="orderButton" onClick={ () => 

                    this.DisplayForOrder(
                        this.props.hotelForOrder.AllocationId,
                        this.props.hotelForOrder.RoomsNum
                    )}>
                    <div className="orderArrow">
                        <img src={"./images/site/arrow-next.png"} alt=""/>                
                    </div>
                    <div className="orderText2">להזמנה</div>
                </div>
            </div>
           
        </div>
    )
  }
}


export default compose(
    withNofeshService()
  )(HotelForOrderItem);
  